import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Main from '../src/pages/Main/Main';
import './App.css';
import Blog from './component/Blog/Blog';
import ErrorPage from './component/ErrorPage/ErrorPage';
import Home from './component/Home/Home';
import Quiz from './component/Quiz/Quiz';
import Statistics from './component/Statistics/Statistics';
const router = createBrowserRouter([
  {
    path: "/",
    element: <Main/>,    
    children: [
      { 
        path: '/',
        loader: async () => {
          return fetch('https://openapi.programming-hero.com/api/quiz');
        },
        element:<Home/>
      },
      {
        path: '/statistics',loader: async () => {
          return fetch('https://openapi.programming-hero.com/api/quiz');
        },
        element:<Statistics/>
      }, {
        path: '/blog',
        element: <Blog/>
      },
      {
        path: '/quiz/:id',
        loader: async ({params}) => {
          return fetch(`https://openapi.programming-hero.com/api/quiz/${params.id}`);
        },
        element: <Quiz/>
      }
    ],
  },
  {
    path: '*',
    element: <ErrorPage/>
  }
]);

function App() {
  return (
    <div className="App max-w-[1440px] mx-auto">
         <RouterProvider router={router} />
    </div>
  );
}

export default App;
